import React from "react";
import { Box, Paper, IconButton, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

/**
 * Purple-header collapsible panel used by the MicroSlide layouts.
 *
 * Props:
 *   title         - text shown in the purple header bar
 *   collapsed     - boolean, controls whether the body is hidden
 *   onToggle      - fired when the chevron is clicked
 *   headerExtras  - optional ReactNode rendered on the right side of the
 *                   header, just before the collapse chevron. Stays visible
 *                   when the panel is collapsed. Wrap any click handlers in
 *                   e.stopPropagation() to keep them from toggling collapse.
 */
export default function CollapsiblePanel({ title, collapsed, onToggle, children, headerExtras }) {
    return (
        <Paper elevation={3} sx={{ display: "flex", flexDirection: "column", mt: 2 }}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                bgcolor="#774def"
                color="#ffffff"
                px={2}
                py={1}
            >
                <Typography variant="subtitle1">{title}</Typography>
                <Box display="flex" alignItems="center" gap={1}>
                    {headerExtras}
                    <IconButton size="small" onClick={onToggle} sx={{ color: "white" }}>
                        {collapsed ? <ExpandMore /> : <ExpandLess />}
                    </IconButton>
                </Box>
            </Box>
            <Box flex={1} overflow="auto" p={2} sx={{ display: collapsed ? "none" : "block" }}>
                {children}
            </Box>
        </Paper>
    );
}
